import React from 'react';
import MassMessageLegacy from '../../../../components/Routes/Reports/MassMessage';

const MassMessageReportGate = props => {
  return <MassMessageLegacy {...props} />;
};

export default MassMessageReportGate;
